//arbitrary number, can be changed
export const maxFileSize = 12582912;
export const maxFileSizeError =
  'File too big! Please make sure it is 12MB or less.';
